import { EvaluatorType } from "./evaluatorSlice";
import { createRestSlice } from "./restSlice";

export type EvaluationStatus = "pending" | "complete" | "error";
export type EvaluationTrigger = "automatic" | "manual" | "manual_batch";

type EvaluationSessionInfo = {
  origin: string | null;
  agentEnvironmentId?: string;
  environment?: string;
  status: string;
  createdAt: Date;
};

export type EvaluationBase = {
  id: string;
  sessionId: string;
  evaluatorId: string;
  evalType: EvaluatorType;
  status: EvaluationStatus;
  trigger: EvaluationTrigger;
  errorMessage?: string;
  promptTokens?: number;
  completionTokens?: number;
  cost?: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  organizationSecretName?: string | null;
  session?: EvaluationSessionInfo;
};

export type JudgeRuling = EvaluationBase & {
  evalType: EvaluatorType.JUDGE;
  success?: boolean;
  ruling?: Record<string, unknown>;
  rulingSchema: Record<string, unknown>;
  successCriteria: Record<string, unknown>;
  apiProvider?: string;
  model?: string;
};

export type AgentExtraction = EvaluationBase & {
  evalType: EvaluatorType.EXTRACTION;
  extraction?: Record<string, unknown> | string;
  extractionSchema?: Record<string, unknown>;
  apiProvider?: string;
  model?: string;
};

export type Evaluation = JudgeRuling | AgentExtraction;

const agentEvaluationSlice = createRestSlice<Evaluation>("agentEvaluations", "/v1/agents/:agentId/evaluations");
const sessionEvaluationSlice = createRestSlice<Evaluation>("sessionEvaluations", "/v1/sessions/:sessionId/evaluations");
const evaluatorEvaluationSlice = createRestSlice<Evaluation>("evaluatorEvaluations", "/v1/evaluators/:evaluatorId/evaluations");

export const agentEvaluationReducer = agentEvaluationSlice.reducer;
export const agentEvaluationActions = agentEvaluationSlice.actions;

export const sessionEvaluationReducer = sessionEvaluationSlice.reducer;
export const sessionEvaluationActions = sessionEvaluationSlice.actions;

export const evaluatorEvaluationReducer = evaluatorEvaluationSlice.reducer;
export const evaluatorEvaluationActions = evaluatorEvaluationSlice.actions;
